<div class="protocol-row-compact" *ngIf="mode == 'compact'">
    <div style="position:relative;">
        <div style="float:left;"><fa-icon (click)="editProtocol()" [icon]="['fas', 'file-signature']" class="edit-icon" size="lg"></fa-icon></div>
        <div style="float:right;">{{ date }}</div>
    </div>
    <div style="clear:both;">{{ record.value }}</div>
</div>
<div class="protocol-row-full" *ngIf="mode == 'full'">
    <div class="flex-container protocol-row-header" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
        <div fxFlex="80px">
            <div>
                <div class="flex-container protocol-row-icons" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
                    <fa-icon (click)="editProtocol()" [icon]="['fas', 'file-signature']" class="edit-icon" size="lg"></fa-icon>
                    <fa-icon (click)="openAccess()" [icon]="['fas', 'user-lock']" class="access-icon" size="lg"></fa-icon>
                </div>
            </div>
            <div class="row-date">{{ date }}</div>
        </div>
        <div fxFlex="grow">
            <div class="protocol-content" [innerHtml]="content | crToBr | safeHtml"></div>
        </div>
        <div fxFlex="250px" class="protocol-thumbnails">
            <div *ngFor="let fileid of files" class="protocol-thumbnail">
                <img src="/SN/StVaast/ProtocolFileThumbnail.php?fileid={{fileid}}">
            </div>
        </div>
    </div>
</div>